const MIN_PASSWORD_LENGTH = 8;
const LOWER_CASE_LETTER_REGEX = /.*[a-z].*/;
const UPPER_CASE_LETTER_REGEX = /.*[A-Z].*/;
const NUMBER_REGEX = /.*\d.*/;
const SPECIAL_CHARACTERS_REGEX = /.*[!@#$%^&*].*/;
const DECIMAL_INPUT_REGEX = /^(\$?\d+(\.\d*)?)?$/;

export const validatePassword = (password: string) => {
  const hasMinCharacters = password.length >= MIN_PASSWORD_LENGTH;

  const hasLowerCaseCharacter = LOWER_CASE_LETTER_REGEX.test(password);
  const hasUpperCaseCharacter = UPPER_CASE_LETTER_REGEX.test(password);
  const hasNumber = NUMBER_REGEX.test(password);
  const hasSpecialCharacter = SPECIAL_CHARACTERS_REGEX.test(password);

  const hasMinimumValidations = [
    hasLowerCaseCharacter,
    hasUpperCaseCharacter,
    hasNumber,
    hasSpecialCharacter,
  ].every((value) => value);

  const passwordValid = hasMinCharacters && hasMinimumValidations;

  return {
    hasMinCharacters,
    hasLowerCaseCharacter,
    hasUpperCaseCharacter,
    hasNumber,
    hasSpecialCharacter,
    hasMinimumValidations,
    passwordValid,
  };
};

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  return /^\d{10}$/.test(phoneNumber);
};

export const isValidDecimalInput = (input: string) => {
  if (!input) return true;

  return DECIMAL_INPUT_REGEX.test(input);
};
